import { render, staticRenderFns } from "./WarehouseItemListView.vue?vue&type=template&id=a50454e4"
import script from "./WarehouseItemListView.vue?vue&type=script&lang=js"
export * from "./WarehouseItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports